<div class="relative">
  @if (target()) {
    <a
      [finLink]="target().url"
      [external]="target().external"
      [openInNewTab]="target().openInNewTab"
      class="no-underline"
    >
      <fin-text-on-image-no-link
        [imageData]="imageData()"
        [teaserTitle]="teaserTitle()"
        [teaserText]="teaserText()"
        [imageAspectRatio]="imageAspectRatio()"
      />
      @if (target().openInNewTab) {
        <span data-testid="vishidden-element" class="is-vishidden">({{ 'ariaLabels.newTab' | finLocalization }})</span>
      }
    </a>
  } @else {
    <fin-text-on-image-no-link
      [imageData]="imageData()"
      [teaserTitle]="teaserTitle()"
      [teaserText]="teaserText()"
      [imageAspectRatio]="imageAspectRatio()"
    />
  }
</div>
